import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "_flexcol _gap-4 _gap-6--l" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_backer_center_update_feed_card = _resolveComponent("backer-center-update-feed-card")
  const _component_backer_center_project_recommendations_section = _resolveComponent("backer-center-project-recommendations-section")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.firstTwoUpdates, (update) => {
      return (_openBlock(), _createBlock(_component_backer_center_update_feed_card, _mergeProps({
        key: update.projectUpdateID
      }, { ref_for: true }, update), null, 16 /* FULL_PROPS */))
    }), 128 /* KEYED_FRAGMENT */)),
    _createVNode(_component_backer_center_project_recommendations_section, { "extra-large-screen-visible-items-count": 3 }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.remainingUpdates, (update) => {
      return (_openBlock(), _createBlock(_component_backer_center_update_feed_card, _mergeProps({
        key: update.projectUpdateID
      }, { ref_for: true }, update, {
        "data-qa": `updates-feed-card:${update.projectUpdateID}`
      }), null, 16 /* FULL_PROPS */, ["data-qa"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}